import React, { useMemo } from 'react';

import { useUserHasBillingAccess } from '@hcs/auth';
import { SubNav } from '@hcs/design-system';
import { useExperienceFlag } from '@hcs/experience-flags';
import { VIEW_PATHS_ORG_ADMIN } from '@hcs/hc-products';
import { useOmSftpAccess } from '@hcs/order-manager';

const dataHcName = 'organization-left-nav';
export const OrgAdminNav = () => {
  const { data: hasOMAccess } = useOmSftpAccess();
  const { data: hasBillingAccess } = useUserHasBillingAccess();
  const experienceFlagPexpSettings = useExperienceFlag('PEXP_REPORT_API');
  const AccountOptions = [
    {
      label: 'Usage',
      navigateTo: VIEW_PATHS_ORG_ADMIN.ORG_USAGE,
      dataHcName: 'usage'
    }
  ];
  hasBillingAccess &&
    AccountOptions.push({
      label: 'Billing',
      navigateTo: VIEW_PATHS_ORG_ADMIN.ORG_BILLING,
      dataHcName: 'billing'
    });

  const SUB_NAV_ITEMS_CONFIG = [
    {
      label: 'Account',
      dataHcName: 'account-header',
      navigateTo: VIEW_PATHS_ORG_ADMIN.ORG_USAGE,
      children: AccountOptions
    },
    {
      label: 'Team',
      dataHcName: 'team-header',
      navigateTo: VIEW_PATHS_ORG_ADMIN.ORG_USERS,
      children: [
        {
          label: 'Users',
          navigateTo: VIEW_PATHS_ORG_ADMIN.ORG_USERS,
          dataHcName: 'users'
        }
      ]
    }
  ];

  const subNavItemsConfig = useMemo(() => {
    const items = [...SUB_NAV_ITEMS_CONFIG];

    if (experienceFlagPexpSettings) {
      items.push({
        label: 'PEXP',
        dataHcName: 'pexp',
        navigateTo: VIEW_PATHS_ORG_ADMIN.ORG_REPORT_PREFERENCES,
        children: [
          {
            label: 'Report Settings',
            navigateTo: VIEW_PATHS_ORG_ADMIN.ORG_REPORT_PREFERENCES,
            dataHcName: 'report-preferences'
          }
        ]
      });
    }
    if (hasOMAccess) {
      items.push({
        label: 'Order Manager',
        dataHcName: 'order-manager-header',
        navigateTo: VIEW_PATHS_ORG_ADMIN.ORG_OM_SFTP,
        children: [
          {
            label: 'SFTP',
            navigateTo: VIEW_PATHS_ORG_ADMIN.ORG_OM_SFTP,
            dataHcName: 'sftp'
          }
        ]
      });
    }
    return items;
  }, [hasOMAccess, experienceFlagPexpSettings]);
  return (
    <SubNav
      dataHcName={`${dataHcName}-sub-nav`}
      subNavItemsConfig={subNavItemsConfig}
    />
  );
};
